import { render, staticRenderFns } from "./cq.vue?vue&type=template&id=771247af&scoped=true&"
import script from "./cq.vue?vue&type=script&lang=ts&"
export * from "./cq.vue?vue&type=script&lang=ts&"
import style0 from "./cq.vue?vue&type=style&index=0&id=771247af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771247af",
  null
  
)

export default component.exports